import React from "react";
import { Typography } from "@mui/material";

import Slider from "react-slick";
import ChannelSliderArrow from "./ChannelSliderArrow";

const channels = [
  "Facebook",
  "WhatsApp",
  "Telegram",
  "Messenger",
  "Instagram",
  "Twitter",
  "Reclame aqui"
];

export default function ChannelSlider() {
  return (
    <Slider
      nextArrow={<ChannelSliderArrow />}
      prevArrow={<ChannelSliderArrow />}
      infinite
      vertical
      autoplay
      autoplaySpeed={1600}
    >
      {channels.map(channel => (
        <Typography
          key={channel}
          component="p"
          sx={{ lineHeight: "1.5 !important", fontWeight: 800 }}
          color="black"
          fontSize={48}
        >
          {channel}
        </Typography>
      ))}
    </Slider>
  );
}
